// extracted by mini-css-extract-plugin
export default {"timerWrapper":"styles_timerWrapper__aoNE4","timerIcon":"styles_timerIcon__iDquH","timer":"styles_timer__2ub47"};